import React from "react";
import { Phone } from "lucide-react";
import {
  DEFAULT_PHONE_COUNTRY,
  PHONE_COUNTRY_OPTIONS,
  digitsOnly,
  formatPhoneForApi,
} from "@/lib/phone";

/**
 * Country dial code + national number. Calls onChange with E.164-style digit string for the API.
 */
const PhoneInput = ({
  dialCode,
  nationalNumber,
  onDialCodeChange,
  onNationalNumberChange,
  placeholder = "647 555 0100",
  disabled = false,
  "data-testid": testId = "phone-input",
}) => {
  const dial = dialCode || DEFAULT_PHONE_COUNTRY.dial;

  return (
    <div className="flex gap-2" data-testid={testId}>
      <div className="w-[9.5rem] shrink-0">
        <select
          data-testid={`${testId}-country`}
          value={dial}
          disabled={disabled}
          onChange={(e) => onDialCodeChange?.(e.target.value)}
          className="w-full h-full min-h-[48px] bg-spike-elevated border border-white/10 px-2 py-3 text-spike-text focus:border-spike-blue focus:outline-none font-exo text-sm appearance-none cursor-pointer"
          aria-label="Country code"
        >
          {PHONE_COUNTRY_OPTIONS.map((c) => (
            <option key={`${c.iso}-${c.dial}`} value={c.dial}>
              {c.label}
            </option>
          ))}
        </select>
      </div>
      <div className="relative flex-1">
        <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-spike-dim pointer-events-none" />
        <input
          type="tel"
          inputMode="tel"
          autoComplete="tel-national"
          disabled={disabled}
          data-testid={`${testId}-number`}
          value={nationalNumber}
          onChange={(e) => onNationalNumberChange?.(e.target.value)}
          placeholder={placeholder}
          className="w-full bg-spike-elevated border border-white/10 pl-10 pr-4 py-3 text-spike-text placeholder:text-spike-dim focus:border-spike-blue focus:outline-none font-exo"
        />
      </div>
    </div>
  );
};

export { formatPhoneForApi, digitsOnly };
export default PhoneInput;
